import { useParams, useSearchParams } from 'react-router-dom';
import { M200Wizard } from '@/components/compliance/M200Wizard';
import { ShieldCheck } from 'lucide-react';

export default function CompliancePage() {
    const { id } = useParams<{ id: string }>();
    const [searchParams] = useSearchParams();
    const isSetupMode = searchParams.get('setup') === 'true';

    if (!id) return null;

    return (
        <div className="min-h-screen bg-gray-50 pb-12">
            <div className="bg-white border-b px-4 py-6 shadow-sm sm:px-6 lg:px-8">
                <div className="mx-auto max-w-7xl">
                    <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100 text-blue-600">
                            <ShieldCheck className="h-6 w-6" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">Compliance Manager</h1>
                            <p className="text-sm text-gray-500">
                                {isSetupMode ? 'Initial Setup for New Property' : 'Manage Property Compliance'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
                {isSetupMode && (
                    <div className="mb-8 rounded-lg border border-blue-200 bg-blue-50 p-4 text-blue-800">
                        <p className="font-medium">Welcome to the compliance setup wizard.</p>
                        <p className="text-sm mt-1">
                            To generate a valid R-400 Maintenance Plan, we need to gather some details about your property's
                            structural, life-safety, and mechanical elements.
                        </p>
                    </div>
                )}

                <M200Wizard propertyId={id} />
            </main>
        </div>
    );
}
